﻿import { createElement } from "./_dom";

let errors = null;

function formatError({ message, filename, lineno, colno }) {
	if (/ResizeObserver/.test(message))
		return;

	try {
		const pathname = new URL(filename).pathname;
		const slashPos = pathname.lastIndexOf("/") + 1;
		filename = pathname.substring(slashPos);
	} catch (e) {
	}
	return `${filename}(${lineno},${colno}): ${message}\r\n`;
}

function ensureConsole() {
	if (window.V3?.console) {
		const footer = document.getElementById("td-footer");
		if (footer) {
			let consoleDiv = document.getElementById("td-errorconsole");
			if (!consoleDiv) {
				consoleDiv = createElement("div", { id: "td-errorconsole", class: "v3-errorconsole" });
				footer.append(consoleDiv);
			}
			return consoleDiv;
		}
	}
}

window.addEventListener("error", event => {
	const errorMessage = formatError(event);
	if (errorMessage) {
		const consoleDiv = ensureConsole();
		if (consoleDiv) {
			consoleDiv.append(errorMessage);
		} else {
			if (!errors) errors = [];
			errors.push(errorMessage);
		}
	}
});

function init() {
	if (errors) {
		const consoleDiv = ensureConsole();
		consoleDiv?.append(...errors);
		errors = null;
	}
}

export { init };
